import React from 'react'
import RadioButton, { RadioButtonGroup } from '@ublique/components/RadioButton'

function Radio({ onChange, value, items, className, disabled }) {
  const handleOnChange = (e) => {
    onChange({ params: { value: e, label: e } })
  }
  return (
    <RadioButtonGroup
      className={`${className}-radio`}
      name='radio-button-group'
      defaultSelected={value}
      onChange={handleOnChange}
      disabled={disabled}
    >
      {items.map((item, k) => (
        <RadioButton
          key={k}
          id={item.label}
          labelText={item.label}
          value={item.value}
        />
      ))}
    </RadioButtonGroup>
  )
}

export default Radio
